import { render } from "./PodcastShow.vue?vue&type=template&id=8ce926b6"
import script from "./PodcastShow.vue?vue&type=script&lang=js"
export * from "./PodcastShow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Freaz/rk/rk.off-vue/rk.off-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__